import SettingFrame from "../../../../components/@settings/SettingFrame";
import NewUserRole from "../../../../components/@user_roles/roles/NewUserRole"

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function UserRoleNewPage() {

    // return NewUserRole({
    //     routeType: routeTypes.admin
    // })

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <NewUserRole
                routeType={routeType}
            />
        </SettingFrame>
    )
}